import React from "react";
import olaplexBanner from "./../../../../../Images/Blog/How Olaplex Helps/Banner.png";
const HowOlaplexImg = () => {
  return (
    <div className="blogImg-content">
      <img src={olaplexBanner} alt="olaplexBanner" loading="lazy" />
    </div>
  );
};

export default HowOlaplexImg;
